<div class="content-header">
    <h2>Configuración días inhábiles</h2>
</div>
@if(loading){
<div class="loading-overlay">
    <div class="loading-indicator">Cargando registros...</div>
</div>
}


<div class="servicio-filtros">
    <label class="form-label mb-1" for="organismoSelect">Seleción de Órgano</label>
    <div class="row">
        <div class="col-md-10">
            <ng-select placeholder="Seleccione una opción" id="organismoSelect" name="organismoSelect" class="select-v2"
                [(ngModel)]="selectedOrganismoId" [disabled]="organosLoading || loading"
                (change)="onChangeOrgano($event)">
                @if(isOrganismoAdmin || bSuperAdmin){
                <ng-option [value]="0">{{TipoOrganismo}} (General)</ng-option>
                }
                @for (organo of organos; track $index) {
                <ng-option [value]="organo.courtId">
                    {{ organo.courtId }} - {{ organo.courtName }}
                </ng-option>
                }
            </ng-select>
        </div>
        <div class="col-md-2 d-flex justify-content-start">
            <button class="btn btn-outline-success btn-sm" (click)="agregarConfiguracion(registro)"
                [disabled]="loading || organosLoading || selectedOrganismoId === null">
                <i class="fas fa-plus"></i>
                Agregar dia inhábil
            </button>
        </div>
    </div>


    @if(organosLoading){
    <div class="form-text">Cargando catalogo...</div>
    }
    @if(organosError){
    <div class="text-danger small">{{ organosError }}</div>
    }
</div>
<br>

<oaj-alert-itx></oaj-alert-itx>

<div class="table-container mt-3">
    <h3 class="h3-title">Registros Activos:</h3>

    <form class="filter-bar" [formGroup]="formFiltro" (ngSubmit)="onSubmitFiltro()">
        <div class="contFiltr">
            <div class="up">Filtrar por estatus:</div>
            <div class="down">
                <select formControlName="estado">
                    <option value="" disabled>Seleccione un estatus</option>
                    @for (e of estados; track $index) {
                    <option [value]="e.value">
                        {{ e.key }}
                    </option>
                    }
                </select>
                <input type="date" class="date-input eligeFecha" formControlName="fechaInicio" hidden />&nbsp;
                <input type="date" class="date-input eligeFecha" formControlName="fechaFin" hidden />&nbsp;
                <button type="submit" class="btn-search">
                    <i class="fas fa-search"></i> Buscar
                </button>
            </div>
        </div>
    </form>

    <table>
        <thead>
            <tr>
                <th>Órgano impartidor de justicia / Autoridad</th>
                <th>Motivo</th>
                <th>Fecha de inicio</th>
                <th>Fecha de fin</th>
                <th>Estatus</th>
                <th>Archivo</th>
                <th>Editar</th>
                <th>Baja</th>
            </tr>
        </thead>
        <tbody>
            @for (day of DaysLst; track day.idConfigDiasInhabiles) {
            <tr>
                @if(day.ioij===0){
                <td>{{day.organoAutoridad}} (General)</td>
                }
                @else {
                <td>{{day.organoAutoridad}}</td>
                }
                <td>{{day.motivo}}</td>
                <td>{{day.fechaIncio| date:'dd/MM/yyyy HH:mm'}}</td>
                <td>{{day.fechaFin| date:'dd/MM/yyyy HH:mm'}}</td>
                <td>
                    <span
                        [ngClass]="day.estado === 1 ? 'green-circle': day.estado === 0 ? 'red-circle' : 'orange-circle'"
                        class="circle"></span>
                    {{ Estado[day.estado]}}
                </td>
                <td>
                    <button class="icon-button" ngbTooltip="Visualizar" (click)="abrirModal(day.idConfigDiasInhabiles)">
                        <i class="fas fa-eye iconDescarga"></i>
                    </button>
                </td>
                <td>
                    <button class="icon-button" ngbTooltip="Editar" [disabled]="day.estado !== 2"
                        (click)="editarConfiguracion(day)">
                        <i class="fas fa-edit"></i>
                    </button>
                </td>
                <td>
                    <button class="icon-button" ngbTooltip="Dar de Baja"
                        (click)="InactivarDiaInhabil(day.idConfigDiasInhabiles)" [disabled]="day.estado !== 2">
                        <i class="fas fa-trash-alt"></i>
                    </button>
                </td>
            </tr>
            }
        </tbody>
    </table>
</div>


<!-- Contenido del modal Registro -->
<ng-template #registro let-modal id="modalregistro">

    <form #RegDIhForm (ngSubmit)="onSubmitRegistro()">
        <div class="modal-header">
            <h4 class="modal-title">{{ Edicion ? 'Editar día inhábil' : 'Registro de días inhábiles' }}</h4>
        </div>
        <div class="modal-body">

            <!-- motivo -->
            <div class="form-group">
                <label for="motivo">Motivo:
                    @if(RegDIhForm['txtMotivo']?.value?.trim()==='' && submittedReg){
                    <span [className]="RegDIhForm['txtMotivo']?.value?.trim()===''?'requerido':''"
                        style="font-size: smaller;color: red;">Es requerido</span>
                    }
                </label>
                <textarea class="form-control" id="motivo" name="txtMotivo"
                    [ngClass]="RegDIhForm['txtMotivo']?.value===''?'error':''" [(ngModel)]="InsertEntity.motivo"
                    rows="5" maxlength="60"></textarea>
            </div>

            <!--fecha inicio-->
            <div class="form-group mt-3">
                <label for="fechaInicioI">Fecha de inicio:
                    @if(RegDIhForm['fechaInicio']?.value===''&& submittedReg){
                    <span [className]="RegDIhForm['fechaInicio']?.value===''?'requerido':''"
                        style="font-size: smaller;color: red;">Es requerido</span>
                    }
                </label>
                <div class="input-group mt-3">
                    <input class="form-control" type="datetime-local"
                        [ngClass]="RegDIhForm['fechaInicio']?.value===''?'error':''" name="fechaInicio"
                        [(ngModel)]="InsertEntity.fechaInicioStruct" [ngModelOptions]="{standalone: true}">
                </div>

            </div>
            <!--fecha fin-->
            <div class="form-group">
                <label for="fechaFin">Fecha de fin:
                    @if(RegDIhForm['fechaFin']?.value===''&& submittedReg){
                    <span [className]="RegDIhForm['fechaFin']?.value===''?'requerido':''"
                        style="font-size: smaller;color: red;">Es requerido</span>
                    }
                </label>
                <div class="input-group">
                    <input class="form-control" name="fechaFin" type="datetime-local"
                        [ngClass]="RegDIhForm['fechaFin']?.value===''?'error':''"
                        [(ngModel)]="InsertEntity.fechaFinStruct" [ngModelOptions]="{standalone: true}">

                </div>
            </div>

            <br>
            <div class="document-upload-section">
                <h3>Adjuntar documento:</h3>
                <p class="formats-info">Formatos válidos de archivo: PDF</p>

                <div class="aviso-frame">
                    <p>
                        Al ingresar el documento, verificar que el nombre del archivo no cuente con signos de
                        puntuación,
                        admiración
                        o caracteres especiales como apóstrofes, guiones, etc.
                    </p>
                    <p>
                        Nota: El tamaño límite de los archivos debe ser 40 MB por documento, mismos que en su conjunto
                        no deberán de exceder de 360 MB por envío.
                    </p>
                </div>
                <div class="row mt-3 justify-content-end">
                    <div class="col-12 col-sm-auto">
                        <button class="btn btn-file" (click)="cargaArchivo()"
                            [disabled]="lstDocumentos.length > 0">Seleccionar
                            archivos </button>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-sm-auto">
                    <div class="center">
                        <oaj-loader-itx [loading]="isLoadingFile" [sMensaje]="sMensajeLoad"
                            #loaderSpinner></oaj-loader-itx>
                    </div>
                    @if(!isLoadingFile){
                    <oaj-lista-archivos-itx class="form-control" [archivos]="lstDocumentos" [verBorrar]="true"
                        (BorraDoc)="EliminarDocumentosPantalla($event)" [verPrevisualizar]="true"
                        [OcultaSystemName]="true">
                    </oaj-lista-archivos-itx>
                    }
                </div>
            </div>

            <br>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Cerrar</button>
            <button type="submit" class="btn btn-envio" (click)="modal.close(Edicion ?'Actualizar':'Guardar')">{{
                Edicion ? 'Actualizar' : 'Guardar' }} </button>
        </div>
    </form>

</ng-template>


<ng-template #modalArchivos let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Archivos de la configuración</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
        @if(archivosModalLoading){
        <div>Cargando archivos...</div>
        }
        @if(!archivosModalLoading && archivosModalError){
        <div class="alert alert-danger">
            {{ archivosModalError }}
        </div>
        }
        @if(!archivosModalLoading && !archivosModalError){
        <div>
            <oaj-lista-archivos-itx [archivos]="archivosModal" [verBorrar]="false" [verPrevisualizar]="true"
                [verClasificacion]="false" [verArchivoEnvio]="true"></oaj-lista-archivos-itx>
            @if(!archivosModal.length){
            <div class="alert alert-info">
                No se encontraron archivos para esta configuración.
            </div>
            }
        </div>
        }


    </div>
</ng-template>